import React from 'react';
import Review from './review';
import '../css/Service.css';
import hazardousIllustration from '../assets/hazardous-illustration.svg';
// import hazardousTitle from '../assets/hazardous-title.svg';
import hazardousTitle from '../assets/haz-title-1.jpg';

function HazardousWaste() {
  return (
    <div className="service-page">
      <div className="service-banner">
        <img src={hazardousTitle} alt="Hazardous Waste Banner" className="service-banner-img" />
        <div className="service-banner-overlay"></div>
        <div className="service-banner-content">
          <h1>Hazardous Waste</h1>
        </div>
      </div>

      <header className="service-header">
        <h1>Nationwide Hazardous Waste Programs</h1>
        <p>
          We provide comprehensive hazardous waste management including audits, profiling, minimization, recycling, and disposal under applicable regulations.
        </p>
      </header>

      <section className="service-content">
        <div className="service-content-left">
          <h2>We Have Nationwide Hazardous Waste Programs For:</h2>
          <ul className="feature-list">
            <li>Hazardous waste management — waste audits, profiling, and minimization.</li>
            <li>Hazardous waste recycling — reclaim, reuse, or beneficial reuse of solvents and chemicals.</li>
            <li>Hazardous waste disposal — licensed disposal under applicable regulations for each waste stream.</li>
          </ul>

          <h3>Why Choose Our Hazardous Waste Program?</h3>
          <p>
            Our programs combine regulatory expertise, certified transport, documented chain-of-custody, and options for recycling and recovery where feasible. We tailor plans to your site and provide full records for compliance and audit readiness.
          </p>

          <div className="service-cta">
            <a href="/contact" className="btn btn-primary">Request a Site Assessment</a>
          </div>
        </div>

        <aside className="service-content-right">
          <img src={hazardousIllustration} alt="Hazardous handling illustration" className="specialty-illustration" />
          <div className="specialty-card">
            <h3>Specialty Waste Streams</h3>
            <ol className="specialty-list">
              <li>Infectious waste</li>
              <li>Ignitable / flammable liquids, solids, and sludge</li>
              <li>Chemical waste</li>
              <li>Used solvents</li>
              <li>Corrosive</li>
              <li>Reactive</li>
              <li>Cleaning solutions</li>
              <li>Acids and caustics</li>
              <li>Chemical tanks and drums</li>
              <li>Toxic metals</li>
              <li>Sludges</li>
              <li>Contaminated soils</li>
              <li>Plating solutions</li>
              <li>Waste containing hazardous metals</li>
              <li>And many more...</li>
            </ol>
          </div>
        </aside>

      </section>

      <Review />
    </div>
  );
}

export default HazardousWaste;
